import { track } from '../../vendor/splitmetrics-track/index';



export const EVENT_NAME = 'main_gallery_slide_close';


export default (params) => {
  track(EVENT_NAME, params, {});
};



// WEBPACK FOOTER //
// ./src/lib/track-event/main-gallery-slide-close.js